import { render, staticRenderFns } from "./Ye.vue?vue&type=template&id=68f5b332&scoped=true&"
import script from "./Ye.vue?vue&type=script&lang=js&"
export * from "./Ye.vue?vue&type=script&lang=js&"
import style0 from "./Ye.vue?vue&type=style&index=0&id=68f5b332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f5b332",
  null
  
)

export default component.exports